{
  "error-unable-to-update-notes": "Unable to update client notes. Please try again later",
  "error-unable-to-update-financial-purpose": "Unable to update client financial purpose. Please try again later",
  "error-unable-to-invite": "Unable to send client invitation. Please try again later",
  "error-unable-to-resend-invitation": "Unable to resend client invitation. Please try again later",
  "error-unable-switch-onboarding": "Unable to change onboarding type for client. Please try again later",
  "error-unable-to-update-spending": "Unable to update client spending. Please try again later",
  "client-next-steps-header": "Tasks",
  "client-financial-goals-header": "Goals",
  "client-statement-of-financial-purpose-header": "Statement of Financial Purpose",
  "personal-financial-statement": "Personal Financial Statement",
  "next-steps-and-goals-header": "Tasks and Goals",

  "decayed-dollar-amount": " is out-dated ",
  "total-assets": "Total Assets",
  "total-debts": "Total Debts",
  "client-page-decayed-indicator": " is out-dated",
  "client-page-decayed-indicator-with-percentage": " is out-dated ({{- decayedPercentage }}%)"
}
